import { employeeMiniProfile } from 'interfaces/EmployeeMiniProfile';
import { OneOnOneInsightsColumnsValidator, OneOnOneInsightsRequestI } from 'screens/oneOnOneRabbit/Insights/interfaces';
import { z } from 'zod';

import { getOneOnOneInsightsTabularDataApi } from '../api';

export const OneOnOneInsightsTDataValidator = z
  .array(
    z
      .object({
        '1': z
          .object({
            value: employeeMiniProfile.extend({
              reporteeCount: z.number().nullable(),
              relationType: z.enum(['MANAGER', 'SKIP_MANAGER', 'PEER', 'SKIP_REPORTEE', 'REPORTEE']).nullable(),
            }),
          })
          .optional(),
        '2': z
          .object({
            value: z.union([z.number(), z.string()]).nullable(),
          })
          .optional(),
        '3': z
          .object({
            value: z.number().nullable(),
          })
          .optional(),
        '4': z
          .object({
            value: z.number().nullable(),
          })
          .optional(),
        '5': z
          .object({
            value: z.number().nullable(),
          })
          .optional(),
        '6': z
          .object({
            value: z.number().nullable(),
          })
          .optional(),
        '7': z
          .object({
            value: z.number().nullable().optional(),
          })
          .optional(),
        '8': z
          .object({
            value: z.string().nullable().optional(),
          })
          .optional(),
        '9': z
          .object({
            value: z
              .object({
                BELONGING: z.number().nullable().optional(),
                PERFORMANCE: z.number().nullable().optional(),
                COLLABORATION: z.number().nullable().optional(),
                GROWTH: z.number().nullable().optional(),
                MANAGER_EFFECTIVENESS: z.number().nullable().optional(),
              })
              .nullable()
              .optional(),
          })
          .nullable()
          .optional(),
        '11': z
          .object({
            value: z
              .object({
                workEmail: z.string().nullable().optional(),
                personalEmail: z.string().nullable().optional(),
                email: z.string().nullable().optional(),
              })
              .nullable()
              .optional(),
          })
          .nullable()
          .optional(),
        '12': z
          .object({
            value: z
              .object({
                workEmail: z.string().nullable().optional(),
                personalEmail: z.string().nullable().optional(),
                email: z.string().nullable().optional(),
              })
              .nullable()
              .optional(),
          })
          .nullable()
          .optional(),
        '13': z
          .object({
            value: z.number().nullable(),
          })
          .optional(),
        '14': z
          .object({
            value: z.number().nullable(),
          })
          .optional(),
        hierarchy: z
          .object({
            value: z.array(z.number()).nullable(),
          })
          .optional(),
      })
      .nullable()
  )
  .nullable();

export type OneOnOneInsightsTData = z.infer<typeof OneOnOneInsightsTDataValidator>;

const OneOnOneInsightsTabularValidator = z.object({
  columns: z.array(OneOnOneInsightsColumnsValidator),
  values: OneOnOneInsightsTDataValidator,
});

export const getOneOnOneInsightsTabularData = async ({
  isExpandedViewRequired,
  cohort,
  dateRange,
  groupByKeys,
  orderBy,
}: OneOnOneInsightsRequestI) => {
  try {
    const res = await getOneOnOneInsightsTabularDataApi({
      isExpandedViewRequired,
      cohort,
      dateRange,
      groupByKeys,
      orderBy,
    });
    const validatedData = OneOnOneInsightsTabularValidator.parse(res.entity);
    return validatedData;
  } catch (error) {
    console.error('Error fetching one on one insights tabular data : ', error);
  }
};
